import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { VoucherForm } from "../VoucherForm";
import { EditVoucherModalProps } from "./types";
import { useEditVoucherModal } from "./controller";

export const EditVoucherModal = React.memo(({ modalRef, onComplete }: EditVoucherModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditVoucherModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("voucher_batch_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <VoucherForm />
    </Modal>
  );
});
